import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import quorumbio from 'images/quorumbio/logo1.jpg';
import neodex from 'images/neodex/neodex_logo.png';
import snu from 'images/snu.svg';
import { BsWindowSidebar } from 'react-icons/bs';

const Modal = styled.div`
  box-sizing: border-box;
  position: relative;
  top: 100px;
  display: flex;
  justify-content: center;
  border-radius: 20px;
  width: 350px;
  margin: 0 auto;
`;

const Container = styled.div`
  width: 400px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Icon = styled.div`
  width: 150px;
  cursor: pointer;
  margin-left: 30px;
  margin-right: 30px;

  &:hover {
    background: #eaeaea;
    // background: pink;
  }
`;

export const SponsorPage = () => {
  const navigate = useNavigate();

  const handleQuorumBio = () => {
    navigate('/sponsor/quorumbio');
  };

  const handleNeoDex = () => {
    navigate('/sponsor/neodex');
  };

  return (
    <div className="SponsorPage">
      <Modal>
        <Container>
          <Icon onClick={handleQuorumBio}>
            <img src={quorumbio} alt="snu-image" width="100%" />
          </Icon>
          <Icon onClick={handleNeoDex}>
            <img src={neodex} alt="snu-image" width="100%"/>
          </Icon>
          </Container>
      </Modal>
    </div>
  );
};